'use client';

import Slider, { Settings } from 'react-slick';
import { useEffect, useRef } from 'react';
import { CarouselArrows } from '@components/common/Carousel/CarouselArrows';
import SuccessStoryCard from './SuccessStoryCard';
import 'styles/bj_theme/bj_slick_image_gallery.css';

interface SuccessStoriesCarouselProps {
  className?: string;
  items: ApiSchema<'SuccessStoryCandidate'>[];
  sliderSettings?: Settings;
}

const sliderSettings: Settings = {
  autoplay: false,
  autoplaySpeed: 3000,
  dots: false,
  arrows: true,
  infinite: false,
  slidesToShow: 4,
  rows: 1,
  slidesToScroll: 1,
  nextArrow: <CarouselArrows direction="next" />,
  prevArrow: <CarouselArrows direction="prev" />,
  className: 'bj-slick-image-gallery',
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1.15,
      },
    },
  ],
};

const SuccessStoriesCarousel = (props: SuccessStoriesCarouselProps) => {
  // Props destructuring
  const {
    className = '',
    items,
    sliderSettings: customSliderSettings,
  } = props;
  const sliderRef = useRef<Slider | null>(null);

  useEffect(() => {
    // React slick doesn't automatically start the autoplay when the props change
    if (customSliderSettings?.autoplay) {
      // Start autoplay if it's enabled in custom settings
      sliderRef.current?.slickPlay();
    } else {
      // Stop autoplay if it's disabled in custom settings
      sliderRef.current?.slickPause();
    }
  }, [customSliderSettings?.autoplay]);

  // Render the component
  // ********************************
  return (
    <div className={`relative ${className}`}>
      <Slider ref={sliderRef} {...sliderSettings} {...customSliderSettings}>
        {items?.map((item) => (
          <div className="!flex justify-center">
            <div className="w-72">
              <SuccessStoryCard {...item} />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};
export default SuccessStoriesCarousel;
